"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _nicbaseTranslation = require("nicbase-translation");

var _input = _interopRequireDefault(require("../input"));

var _colorInputModule = _interopRequireDefault(require("./color-input.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ColorInput = function ColorInput(_ref) {
  var className = _ref.className,
      value = _ref.value,
      label = _ref.label,
      hideLabel = _ref.hideLabel,
      disabled = _ref.disabled,
      error = _ref.error,
      _onChange = _ref.onChange,
      intl = _ref.intl;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(_colorInputModule["default"].colorInput, className)
  }, /*#__PURE__*/_react["default"].createElement(_input["default"], {
    value: value,
    label: label,
    hideLabel: hideLabel,
    error: error,
    disabled: disabled,
    onChange: _onChange
  }), /*#__PURE__*/_react["default"].createElement("input", {
    className: _colorInputModule["default"].colorSelector,
    type: "color",
    title: intl.formatMessage({
      id: 'widget.colorinput'
    }),
    value: value,
    disabled: disabled,
    onChange: function onChange(event) {
      if (!disabled) {
        _onChange(event.target.value, event);
      }
    }
  }));
};

ColorInput.propTypes = {
  label: _input["default"].propTypes.label,
  hideLabel: _input["default"].propTypes.hideLabel,
  error: _input["default"].propTypes.error,
  disabled: _input["default"].propTypes.disabled,
  className: _propTypes["default"].string,
  value: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  intl: _nicbaseTranslation.intlShape.isRequired
};

var noop = function noop() {};

ColorInput.defaultProps = {
  label: _input["default"].defaultProps.label,
  hideLabel: false,
  disabled: _input["default"].defaultProps.disabled,
  error: _input["default"].defaultProps.error,
  className: '',
  value: '',
  onChange: noop
};

var _default = (0, _nicbaseTranslation.injectIntl)(ColorInput);

exports["default"] = _default;